(() => {
  document.querySelectorAll("[data-autoplay-video]").forEach((video) => {
    video.muted = true;
    video.playsInline = true;
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(() => {
        const retry = () => {
          video.play().catch(() => {});
          document.removeEventListener("touchstart", retry);
          document.removeEventListener("click", retry);
        };
        document.addEventListener("touchstart", retry, { once: true, passive: true });
        document.addEventListener("click", retry, { once: true });
      });
    }
  });

  const revealItems = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16 });
    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add("is-visible"));
  }

  document.querySelectorAll("[data-product-card]").forEach((card) => {
    card.addEventListener("click", (event) => {
      if (event.target.closest("a, button, form")) return;
      card.classList.toggle("is-open");
    });
  });

  document.querySelectorAll("[data-flavour-select]").forEach((flavour) => {
    const form = flavour.closest("form");
    const tags = form ? form.querySelector("[data-newsletter-tags]") : null;
    if (!tags) return;

    const baseTags = tags.value
      .split(",")
      .map((tag) => tag.trim())
      .filter((tag) => tag && !tag.startsWith("flavour-"));

    const updateFlavourTags = () => {
      const nextTags = [...baseTags, flavour.value]
        .filter(Boolean)
        .filter((tag, index, allTags) => allTags.indexOf(tag) === index);
      tags.value = nextTags.join(",");
    };

    flavour.addEventListener("change", updateFlavourTags);
    updateFlavourTags();
  });

  document.querySelectorAll("[data-comparison-slider]").forEach((slider) => {
    const range = slider.querySelector("[data-comparison-range]");
    if (!range) return;

    const updateSlider = (nextValue = range.value) => {
      const value = Number(nextValue);
      const clamped = Math.min(96, Math.max(4, value));
      range.value = String(clamped);
      slider.style.setProperty("--slider-position", `${clamped}%`);
      slider.style.setProperty("--slider-position-number", String(clamped / 100));
      slider.setAttribute("aria-valuenow", String(Math.round(clamped)));
    };

    const updateFromClientX = (clientX) => {
      const rect = slider.getBoundingClientRect();
      const nextValue = ((clientX - rect.left) / rect.width) * 100;
      updateSlider(nextValue);
    };

    range.addEventListener("input", updateSlider);
    slider.addEventListener("click", (event) => updateFromClientX(event.clientX));
    slider.addEventListener("mousedown", (event) => updateFromClientX(event.clientX));
    slider.addEventListener("mousemove", (event) => {
      if (event.buttons !== 1) return;
      updateFromClientX(event.clientX);
    });
    slider.addEventListener("touchstart", (event) => {
      if (!event.touches.length) return;
      updateFromClientX(event.touches[0].clientX);
    }, { passive: true });
    slider.addEventListener("touchmove", (event) => {
      if (!event.touches.length) return;
      updateFromClientX(event.touches[0].clientX);
    }, { passive: true });
    slider.addEventListener("pointerdown", (event) => {
      slider.setPointerCapture(event.pointerId);
      updateFromClientX(event.clientX);
    });
    slider.addEventListener("pointermove", (event) => {
      if (!slider.hasPointerCapture(event.pointerId)) return;
      updateFromClientX(event.clientX);
    });
    slider.addEventListener("pointerup", (event) => {
      if (slider.hasPointerCapture(event.pointerId)) {
        slider.releasePointerCapture(event.pointerId);
      }
    });
    slider.addEventListener("keydown", (event) => {
      if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
      event.preventDefault();
      if (event.key === "Home") updateSlider(4);
      if (event.key === "End") updateSlider(96);
      if (event.key === "ArrowLeft") updateSlider(Number(range.value) - 6);
      if (event.key === "ArrowRight") updateSlider(Number(range.value) + 6);
    });
    updateSlider();
  });

})();
